import { makeStyles } from '@material-ui/core';
import { neutral, red } from 'shared/styles/colors';

export default makeStyles({
  board: {
    height: 'calc(100% - 3.5rem)',
    marginTop: '1rem',
    display: 'flex',
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
  },
  menu: {
    minWidth: '14rem',
    maxWidth: '18.5rem',
    width: 'fit-content',
    paddingTop: 0,
    fontWeight: 500,
    color: neutral[80],
  },
  navOption: {
    '&.Mui-selected': {
      backgroundColor: neutral[20],
    },
  },
  listingSection: {
    width: '100%',
    overflowY: 'auto',
  },
  listItemText: {
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
  outStock: {
    padding: '1.5rem 1rem',
    gap: '0.5rem',
    color: red[60],
    backgroundColor: red[10],
    borderTopLeftRadius: '0.5rem',
    '&:hover': {
      color: red[70],
      backgroundColor: red[20],
    },
    '&.Mui-selected': {
      color: neutral.white,
      backgroundColor: red[50],
      '&:hover': {
        color: neutral.white,
        backgroundColor: red[50],
      },
    },
  },
  outStockItemText: {
    fontSize: '1rem',
    fontWeight: 'normal',
    lineHeight: '1.25rem',
  },
});
